import { Link, useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const headingStyle = {
    color: "#1e3a8a",
    marginTop: "32px",
    marginBottom: "12px",
    fontSize: "1.35rem",
  };

  const paragraphStyle = {
    marginBottom: "16px",
    textAlign: "justify",
  };

  const listStyle = {
    paddingLeft: "22px",
    marginBottom: "18px",
  };

  return (
    <div
      className="container"
      style={{
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.8,
        background: "#fff",
        color: "#333",
        padding: "48px",
        maxWidth: "900px",
        margin: "80px auto 40px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        border: "1px solid #e5e5e5",
      }}
    >
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: "10px 18px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: 500,
          marginBottom: "30px",
        }}
      >
        ← Back
      </button>

      {/* Title */}
      <h1
        style={{
          color: "#1f2937",
          borderBottom: "3px solid #2563eb",
          paddingBottom: "12px",
          marginBottom: "20px",
        }}
      >
        Privacy Policy
      </h1>

      {/* Effective Date Card */}
      <div
        style={{
          background: "#f3f4f6",
          padding: "16px 20px",
          borderRadius: "8px",
          marginBottom: "30px",
        }}
      >
        <p style={{ margin: 0 }}>
          <strong>Effective Date:</strong> O4th AUG 2026
          <br />
          <strong>Last Updated:</strong> O4th AUG 2026
        </p>
      </div>

      <h2 style={headingStyle}>1. Introduction</h2>

<p style={paragraphStyle}>
  This Privacy Policy applies to all of the products, services and websites
  offered by NIT Calicut. Sometimes, we may post product-specific privacy
  notices or Help Centre materials to explain our services in more detail.
</p>

<p style={paragraphStyle}>
  If you have any questions about this Privacy Policy, please feel free to
  contact us through our website or write to us at{" "}
  <strong>placement@nitc.ac.in</strong>.
</p>

      <h2 style={headingStyle}>2. Information We Collect</h2>

      <p style={paragraphStyle}>
        <strong>a. Google Authentication Data</strong>
        <br />- Email address only, via Google Sign-In.
      </p>

      <p style={paragraphStyle}>
        <strong>b. Personal and Academic Information</strong>
        <br />- Full name
        <br />- Date of birth
        <br />- Aadhaar ID
        <br />- APAAR ID
        <br />- Contact number
        <br />- CGPA and education history
        <br />- Uploaded documents (marksheets, ID proofs, resume, etc.)
      </p>

      <h2 style={headingStyle}>3. Purpose of Data Collection</h2>

      <p style={paragraphStyle}>Your data is collected to:</p>

      <ul style={listStyle}>
        <li style={{ marginBottom: "8px" }}>
          Verify your identity and eligibility
        </li>
        <li style={{ marginBottom: "8px" }}>
          Facilitate internship matching
        </li>
        <li style={{ marginBottom: "8px" }}>
          Prevent fraudulent applications
        </li>
      </ul>

      <h2 style={headingStyle}>4. Data Security</h2>

      <p style={paragraphStyle}>
        Access restricted to authorized personnel
        <br />
        We do <strong>not sell</strong> your data.
        <br />
        Your data may be shared with government or legal bodies (if required)
      </p>

      <h2 style={headingStyle}>6. Data Retention & Deletion</h2>

      <p style={paragraphStyle}>
        Our standard policy is to retain user data for{" "}
        <strong>up to 3 years</strong> from the date of submission but actual
        deletion timelines may vary due to operational or legal requirements.
      </p>

      <p style={paragraphStyle}>
        <em>
          We are not responsible for recovering any data after this period ends.
        </em>
      </p>

      <h2 style={headingStyle}>7. Changes to our Privacy Policy</h2>

<p style={paragraphStyle}>
  NIT Calicut reserves the entire right to modify, amend, or remove this
  Privacy Policy at any time and without any reason. Nothing contained herein
  creates or is intended to create a contract or agreement between NIT
  Calicut and any user visiting this website or providing identifying
  information of any kind.
</p>

<h2 style={headingStyle}>8. Consent</h2>

<p style={paragraphStyle}>
  By using our platform, you consent to this Privacy Policy and our handling of
  your data.
</p>

      {/* Contact Card */}
      <div
        style={{
          marginTop: "40px",
          padding: "18px",
          background: "#eef6ff",
          borderLeft: "4px solid #2563eb",
          borderRadius: "8px",
        }}
      >
        <strong>Questions?</strong>
        <br />
        📧 placement@nitc.ac.in
      </div>

      {/* Bottom Navigation */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "40px",
          paddingTop: "20px",
          borderTop: "1px solid #ddd",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <Link
          to="/termsandcondition"
          style={{
            textDecoration: "none",
            color: "#2563eb",
            fontWeight: 600,
          }}
        >
          ← Terms of Service
        </Link>

        <Link
          to="/Refundpolicy"
          style={{
            textDecoration: "none",
            color: "#2563eb",
            fontWeight: 600,
          }}
        >
          Refund Policy →
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
